import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch, useAppSelector } from '../../../store';
import { closeDialog } from '../../../store/slices/dialogSlice';
import * as S from './styles';

const Dialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isOpen, type, message, onConfirm, onClose } = useAppSelector(
    (state) => state.dialog
  );

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return faCheckCircle;
      case 'error':
        return faTimesCircle;
      case 'confirm':
        return faQuestionCircle;
      default:
        return faExclamationTriangle;
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    dispatch(closeDialog());
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    dispatch(closeDialog());
  };

  return (
    <S.ModalOverlay onClick={handleClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.IconContainer type={type}>
          <FontAwesomeIcon icon={getIcon()} />
        </S.IconContainer>

        <S.Message>{message}</S.Message>

        <S.ButtonContainer>
          {type === 'confirm' ? (
            <>
              <S.CancelButton onClick={handleClose}>Não</S.CancelButton>
              <S.ConfirmButton onClick={handleConfirm} autoFocus>
                Sim
              </S.ConfirmButton>
            </>
          ) : (
            <S.CloseButton onClick={handleClose} autoFocus>
              OK
            </S.CloseButton>
          )}
        </S.ButtonContainer>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};

export default Dialog;
